<template>
  <v-card
    class="ma-0 mt-0 pt-0"
    width="100%"
    flat
  >
    <v-card-title class="pt-0">
      {{ $t('exchangePriceLang') }}
    </v-card-title>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-shortkey="['f2']"
          v-bind="attrs"
          icon
          small
          class="float-left"
          @shortkey="addRecord()"
          v-on="on"
          @click="addRecord()"
        >
          <v-icon
            color="teal"
            style="font-size: 22px"
          >
            mdi-plus-box-outline
          </v-icon>
        </v-btn>
      </template>
      <span>{{ $t('newRow') }} (f2)</span>
    </v-tooltip>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>
                      #
                    </th>
                    <th>
                      {{ $t('fromLanguage') }}
                    </th>
                    <th>
                      {{ $t('toLanguage') }}
                    </th>
                    <th>
                      {{ $t('rate') }} (%)
                    </th>
                    <th>
                      {{ $t('base') }}
                    </th>
                    <th>
                      {{ $t('actions') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, i) in items"
                    :key="i"
                    style="height: 35px"
                  >
                    <td>{{ +i + 1 }}</td>
                    <td>
                      <aicomplete
                        v-model="item.fromLanguage"
                        type="setConfig"
                        :rules="[v => !!v || $t('is-required')]"
                        :new-btn="true"
                        class="mb-3"
                        :data="JSON.stringify({key:'t_languages', type:'translation'})"
                        :val="item.fromLanguage"
                      />
                    </td>
                    <td>
                      <aicomplete
                        v-model="item.toLanguage"
                        type="setConfig"
                        class="mb-3"
                        :rules="[v => !!v || $t('is-required')]"
                        :new-btn="true"
                        :data="JSON.stringify({key:'t_languages', type:'translation'})"
                        :val="item.toLanguage"
                      />
                    </td>
                    <td>
                      <v-text-field
                        v-model="item.rate"
                        height="20"
                        min="0"
                        hide-details
                        type="number"
                        dense
                        outlined
                        class="mb-3 dense"
                        clearable
                        :rules="[v => !!v || $t('is-required')]"
                        @focus="focusEvent"
                      />
                    </td>
                    <td>
                      <v-checkbox
                        v-model="item.base"
                        class="mx-0"
                        value="active"
                      />
                    </td>
                    <td>
                      <div class="d-flex">
                        <v-btn
                          color="green"
                          outlined
                          small
                          class="ms-0 mx-1"
                          :loading="isLoading"
                          @click="submit(item)"
                        >
                          {{ $t('submit') }}
                        </v-btn>
                        <v-btn
                          color="pink"
                          outlined
                          small
                          class="ms-0 mx-1"
                          :loading="isLoading"
                          @click="remove(i)"
                        >
                          {{ $t('remove') }}
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="$emit('close')"
            >
              {{ $t('close') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  import aicomplete from '../../../components/general/AIcomplete/index'
  import General from '../../../../../Mixins/general'
  export default {
    name: 'ExchangePriceDialog',
    components: {
      aicomplete,
    },
    mixins: [General],
    props: ['typeProp', 'getItem'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      render: false,
      isLoading: false,
      alert: false,
      downloadLink: null,
      type: null,
      id: null,
      record: null,
      postPriceExchange: true,
      valid: null,
      items: null,
      file: null,
    }),
    watch: {
      getItem () {
        if (this.getItem) {
          this.getItems()
        }
      },
      typeProp () {
        this.type = this.typeProp
      },
    },
    beforeMount () {
    },
    mounted () {
      this.getItems()
    },
    methods: {
      remove (index) {
        var item = this.items[index]
        var app = this
        if (item.id) {
          app.loading = true
          app.$axios.get(this.$endpoint + 'translationPrice', {
            params: {
              deletePriceExchange: item.id,
            },
          })
            .then(res => {
              res = res.data
              app.items.splice(index, 1)
            })
            .finally(() => (app.loading = false))
        } else {
          app.items.splice(index, 1)
        }
      },
      addRecord () {
        if (!this.items) {
          this.items = {
            id: null,
            fromLanguage: null,
            toLanguage: null,
            rate: null,
            base: null,
          }
        } else {
          this.items.push({
            id: null,
            fromLanguage: null,
            toLanguage: null,
            rate: null,
            base: null,
          })
        }
      },
      submit (item) {
        var app = this
        app.isLoading = true
        app.record = item
        app.$axios.post(this.$endpoint + 'translationPrice', app.$data)
          .then(res => {
            app.getItems()
            // app.$emit('close')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.isLoading = false))
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'translationPrice', {
          params: {
            getPriceExchange: 'active',
          },
        })
          .then(res => {
            res = res.data
            app.items = res
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>

</style>
